import { gql } from '@apollo/client'

export default gql`
  fragment brandInfo on Brand {
    id
    name
  }
`
